// extracted by mini-css-extract-plugin
module.exports = {"modal":"InstructionModal_modal__r1xik"};